import { v4 as uuidv4 } from "uuid";
import { SLOT_TYPES, SOURCES } from "@/config/layoutConfig";

class MaintenanceViewService {
  constructor(store) {
    this.store = store;
  }

  async setMaintenanceView(data) {
    const slots = this.createMaintenanceSlots(data);
    const tabName = `Maintenance ${data.data.unit_data.description}`;

    const tab = await this.store.dispatch("grid/addNewTab", {
      tabName,
      layout: "maintenance",
      slots,
    });

    if (tab.status) {
      await this.store.dispatch("grid/setActiveTab", tab.id);
      this.store.commit("grid/forceLayoutSlots", slots);
    }
  }

  createMaintenanceSlots(data) {
    const slots = [];
    const chartDataId1 = uuidv4();
    const chartDataId2 = uuidv4();
    const chartDataId3 = uuidv4();

    slots.push(this.createPanelDeviceSlot(data.data.alarm_bridge[0]));

    slots.push(this.createUnitsDataSlot(data.data.unit_data, chartDataId1));

    slots.push(this.createPanelConfigSlot(data.data.alarm_bridge[0]));

    slots.push(this.createPlaneSlot(data.data.unit_data));

    slots.push(this.createEventsChartSlot(data.data.unit_data, chartDataId2));

    slots.push(this.createDmpLogsDataSlot(data.data.unit_data, chartDataId3));

    return slots;
  }

  createPanelDeviceSlot(data) {
    return {
      name: `Panel ${data.name}`,
      pos: 1,
      data: data,
      type: SLOT_TYPES.ALARM_BRIDGE_PANEL,
      id: "71a8b78a-cd8d-4e8a-a7ef-fed4038ffae5",
    };
  }

  createUnitsDataSlot(data, chartDataId) {
    return {
      name: "Units Data",
      pos: 2,
      data: {
        chart_id: chartDataId,
        model: "Unit",
        filters: {},
      },
      type: SLOT_TYPES.CHARTS_SDK_DATA,
      id: "71a8b78a-cd8d-4e8a-a7ef-fed4038ffae4",
    };
  }

  createPanelConfigSlot(data) {
    const newData = { ...data };
    newData['isConfig'] = true;
    return {
      name: "DMP Panel Setup",
      pos: 3,
      data: newData,
      type: SLOT_TYPES.ALARM_BRIDGE_PANEL,
      id: "71a8b78a-cd8d-4e8a-a7ef-fed4038ffae4",
    };
  }

  createPlaneSlot(data) {
    return {
      name: `Plane ${data.description}`,
      pos: 4,
      data: {
        planes_url: data.unit_planes,
        unit_id: data.id,
      },
      type: SLOT_TYPES.PLANE,
      id: "9c05f0f1-ae94-4824-8da2-d4e6c0976fbc",
    };
  }

  createEventsChartSlot(data, chartDataId) {
    return {
      name: "Chart Events",
      pos: 5,
      data: {
        chartData: {
          id: chartDataId,
          chartId: chartDataId,
          data: [],
          name: "Alarms",
          chart: "bar",
          field: "created",
          model: "Alarm",
          filters: { units: [data.id] },
          keep_filters: ["units"],
          date_field: null,
        },
      },
      type: SLOT_TYPES.CHARTS_SDK,
      id: "125214e7-8d52-44a8-b6c2-cdd518b59067",
    };
  }

  createDmpLogsDataSlot(data, chartDataId) {
    return {
      name: "Dmp Logs",
      pos: 6,
      data: {
        chart_id: chartDataId,
        model: "DmpLog",
        filters: { units: [data.id] },
      },
      type: SLOT_TYPES.CHARTS_SDK_DATA,
      id: "71a8b78a-cd8d-4e8a-a7ef-fed4038ffae4",
    };
  }
}

export default MaintenanceViewService;
